import {Pipe, PipeTransform} from '@angular/core';
import ShippingRuleModel from '../../_models/shipping-rule.model';
import {ShippingProvider} from '../../_enums/self-ship/shipping-provider.enum';

@Pipe({
    name: 'providerImageUrl',
    pure: true
})
export class ProviderImageUrlPipe implements PipeTransform {
    transform(provider: string): string {
        const key = (provider ?? '').toString();
        const normalized = key.substring(key.indexOf('_') + 1).toLowerCase();

        if (normalized === 'temu') {
            return 'assets/media/logos/stores/temu.png';
        }

        return `assets/media/icons/svg/Shipping/icon-${normalized}-circle.svg`;
    }
}
